import { Injectable } from '@angular/core';
import { BaseProductService } from './base-product.service';
import { IProductCreationParams, IProductBase, IProductReservationBase, IProductReservationParams, IProductDeleteParams } from 'model/product.interface';
import { IInsuranceProduct, PaxlistInsurance, PlansReserve, ReservationAdditionalInfo, ReservationIInsuranceProduct } from 'model/insurance-product.interface';
import { formatBirthDate, getInsurancePaxAges, getPaxAge, keyRandomUnique } from 'utils/helpers';

@Injectable({
  providedIn: 'root'
})
export class InsuranceProductService extends BaseProductService {
  deleteProduct(params: IProductDeleteParams): IProductBase {
    throw new Error('Method not implemented.');
  }

  private readonly CATEGORY_ID = 10;
  private readonly CATEGORY_NAME = 'INSURANCE';

  private form: any;

  createProduct(params: IProductCreationParams): IProductBase {

    const { item, product, payload, othersPerCategory } = params;

    if(!this.form) {
      this.form = JSON.parse(localStorage.getItem('form'));
    }

    this.commonsValueProduct(item, product, payload, this.form, othersPerCategory);
    this.setupInsuranceSpecificProperties(item, product,payload, this.form, othersPerCategory);
    item.payloadUpdate = this._payloadUpdateInsurance(payload, item, othersPerCategory);
    item.destination = this.itineraryService.getDestinationInfo(this.form, item);

    return item as IInsuranceProduct;
  }

  validateProduct(item: any): boolean {
    throw new Error('Method not implemented.');
  }


  private commonsValueProduct(item: any, product: any, payload: any, form: any, othersData: any): void {

      item.id = item.planId;
      item.categoryId = this.CATEGORY_ID;
      item.categoryName = this.CATEGORY_NAME;
      item.providerId = product.insurances['0'].provider?.providerId;
      item.providerName = product.insurances['0'].provider?.providerName;
      item.provider = product.insurances['0'].provider;
      item.nameAdapter = othersData?.makeInsurance?.nameAdapter;
      item.title = item.planName;
      item.currency = item.pricing.currency;
      item.updateDate = new Date();
      item.arrivalDate = product.insurances['0'].trip.startDate;
      item.departureDate = product.insurances['0'].trip.endDate;
      item.pax = item.pax;
  }

  private setupInsuranceSpecificProperties(item: any, product: any, payload: any, form: any, othersData: any): void {

      const countPassenger = this.calculatePassengerCounts(item.pax.ages);

      item.adults = countPassenger.adults;
      item.childrens = countPassenger.childrens;
      item.trip = product.insurances[0].trip;
      item.contact = product.insurances[0].contact;
      item.form = form;
      item.payload = payload;
      item.planCode = item.planCode,
      item.idProduct = item.planId,
      item.origin = form?.origin,
      item.nameAdapter = product.insurances[0].nameAdapter,
      item.searchId = "" //this.arrayResults[0].searchId,
      item.providerId = product.insurances[0].provider?.id,
      item.images = product.insurances[0].images;
      item.providerName =  product.insurances[0].provider?.name
      item.profility = item?.profility,
      item.title = item?.planName
      item.productKey = keyRandomUnique();
      item.cancellationPolicies = product.insurances[0].cancellationPolicy,
      item.expiration_date = this.getExpirationDate(product);
      item.bookParam = item?.bookParam;
      item.description = item?.description;
      item.rateClass = item.rateClass; // item.plan.rateClass; ver esto porque llega standar
      item.serviceExtra = this.getServiceExtra(item);

  }

private getExpirationDate(product: any): any {
    const hasCancellationPolicy = product.insurances[0].cancellationPolicy?.length > 0;
    return hasCancellationPolicy
      ? this.adjustDate(product.insurances[0].cancellationPolicy[0].from, -1)
      : product.trip?.startDate;
  }

  private adjustDate(date: string | Date, days: number): string {
        if (!date) return '';

        // Convertir Date a string si es necesario
        let dateStr: string;
        if (typeof date === 'string') {
          dateStr = date;
        } else {
          // Asumiendo que es un objeto Date
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          dateStr = `${year}-${month}-${day}`;
        }

        const d = new Date(dateStr);
        d.setDate(d.getDate() + days);
        return d.toISOString().split('T')[0];
      }

private calculatePassengerCounts(ages: number[]): { adults: number; childrens: number } {
    return ages.reduce((counts, age) => {
      if (age < 18) {
        counts.childrens += 1;
      } else {
        counts.adults += 1;
      }
      return counts;
    }, { adults: 0, childrens: 0 });
  }

private getServiceExtra(item: any): any[] {
    let arr: any[] = [];

    if(item.addonsIncluded && item.addonsIncluded.length > 0) {
      item.addonsIncluded.forEach((addons: any) => {
        arr.push({
          name: addons.name,
          price: addons.cost
        });
      });
    }

    return arr;
  }

    _payloadUpdateInsurance(payload: any, item: any, othersData: any): Object {
    return {
      products: [{
        providerId: item.providerId,
        categoriesId: [10],
        dateBegin: payload.dateBegin,
        agencyId: this.userService._agencyID,
        dateEnd: payload.dateEnd,
        destination: othersData.markInsurance.insurances[0].trip?.destination,
        market: 2,
        insurances: {
          origin: othersData.markInsurance.insurances[0].trip?.origin,
          destination: othersData.markInsurance.insurances[0].trip?.destination,
          tripType:othersData.markInsurance.insurances[0].trip?.tripType,
          planId: item?.planId,
          planCode: item?.planCode,
          bookingCode: item?.bookParam,
          paxList: payload.insurances.paxList
        },

      }]
    };

  }

    // RESERVA

    createReserve(params: IProductReservationParams): IProductReservationBase {

      const { item, paxes, itineraryId, othersPerCategory } = params;
console.log(item)
      const productReservation: ReservationIInsuranceProduct = {
        id: item.id,
        providerId: item.providerId,
        channelId: othersPerCategory.channelId,
        clientId: othersPerCategory.clientIdFusion,
        itinerary_id: itineraryId,
        productId: item.idProduct,
        dateIni: item.arrivalDate,
        dateBegin: item.arrivalDate,
        dateEnd: item.departureDate,
        title: item.title,
        categoryId: item.category_id,
        marketingId: 2,
        additionalInfo: this.setAdditionalInfo(item, paxes, othersPerCategory)
      }

      return productReservation as ReservationIInsuranceProduct;

    }

    private setAdditionalInfo(item: any, paxes: any, othersData: any):  ReservationAdditionalInfo {

      return {
        insuranceId: item.insuranceId,
        planQty: 1, // teng oque ver acá por el agrupamiento
        plans: this.getPlans(item, othersData) // idem, tengo que ver acá por el agrupamiento

      }

    }

    private getPlans(plan: any, othersData: any): PlansReserve[] {

        // if(plans && plans.length === 0) {
        //   return null;
        // }
        const findItem = othersData.itineraryItems.find(c => c.productKey === plan.productKey);
        const comments = findItem?.comments || '';

        const plansArr: PlansReserve[] = [];

        // plans.forEach((plan: any, index: number) => {

          plansArr.push({
            bookingCode: plan.bookingCode,
            planId: plan.planId,
            planCode: plan.planCode,
            maxPax: othersData.paxesInItems.length,
            netPrice: plan.pricing.priceWithoutTax,
            totalNetPrice: plan.pricing.priceWithTax,
            totalPrice: plan.totalPrice,
            tax: plan.pricing.tax,
            percentage: plan.profility.percentage,
            planConfiguration: plan.pax,
            comments,
            contact_emergency: plan.contact_emergency,
            paxList: this.sortPaxListBySearchAges(this.getPaxList(othersData.paxesInItems, othersData.itemId), plan)
          });
        // });

        return plansArr;

    }

    private getPaxList(paxesInItems: any, itemId: any, nationality?: string): PaxlistInsurance[] {
console.log(paxesInItems)
       const paxLength: number = paxesInItems.length;
        const paxesAux: PaxlistInsurance[] = [];
        let paxes = [];
        let n = 1;

        if (paxesInItems !== undefined) {
          // Itera sobre cada array en pax
          paxesInItems.forEach((subArray) => {
            if (Array.isArray(subArray)) {
              // Filtra los elementos cuyo itemId está en la lista proporcionada
              const filteredItems = subArray.filter((item) => itemId == item.itemId);

              // Agrega los elementos filtrados a paxesAux
              paxes.push(...filteredItems);
            }
          });
        }

        if(paxes.length > 0 && itemId !== undefined) {
          for (let i = 0; i < paxes.length; i++) {
              const paxData = this.getPaxData(paxes, i, nationality);
              paxesAux.push(paxData);
              n = i + 1;
          }
        } else {

            const paxAux = paxesInItems;
            for (let i = 0; i < paxAux.length; i++) {
                const paxData = this.getPaxData(paxAux, i, nationality);
                paxesAux.push(paxData);
                n = i + 1;
            }

        }

        return paxesAux;

    }

    /**
     * Ordena los pax en el mismo orden de edades con que se cotizó la asistencia
     * (payloadUpdate.products[0].insurances.paxList.paxAges): el proveedor valida
     * que coincidan posición a posición con la búsqueda.
     * El primero de la búsqueda es el titular, por eso el holder es quien queda primero
     * (no quien se eligió primero en la pantalla de asignación).
     * Los pax cuya edad no figura en la búsqueda quedan al final, en su orden original.
     */
    private sortPaxListBySearchAges(paxList: PaxlistInsurance[], item: any): PaxlistInsurance[] {
        const searchAges = getInsurancePaxAges(item?.payloadUpdate);
        if (searchAges.length === 0 || paxList.length < 2) {
          return paxList;
        }

        const remaining = [...paxList];
        const sorted: PaxlistInsurance[] = [];

        searchAges.forEach((age: number) => {
          const index = remaining.findIndex(pax => Number(pax.age) === age);
          if (index !== -1) {
            sorted.push(...remaining.splice(index, 1));
          }
        });

        return [...sorted, ...remaining].map((pax, index) => ({ ...pax, holder: index === 0 }));
    }

    getPaxData(pax: any, i: number, nationality: string): PaxlistInsurance {
console.log(pax)
              const birth_date = formatBirthDate(pax[i].birth_date);
              const Age = getPaxAge(pax[i], birth_date);

          return {
              clientId: pax[i].clientId || pax[0].clientId,
              gender: pax[i].gender || pax[0].gender,
              title: pax[i].title || pax[0].title,
              firstName: pax[i].first_name?.trim() || pax[0].first_name?.trim() || '',
              lastName: pax[i].last_name?.trim() || pax[0].last_name?.trim() || '',
              identificationType: pax[i].identificationType || pax[0].identificationType,
              identification: pax[i].document_number || pax[0].document_number || '',
              type: pax[i].type === "AD" ? "AD" : "CH",
              birth_date: birth_date ?? undefined,
              age: Age ?? undefined,
              email: pax[i].email?.trim() || pax[0].email?.trim() || '',
              phone: pax[i].phone || pax[0].phone || '',
              address: pax[i].address?.trim() || pax[0].address?.trim() || '',
              nationality: nationality?.trim() || "AR",
              country: pax[i].country_id || pax[0].country_id,
              city: pax[i].city || pax[0].city,
              idUnique: pax[i].idUnique || pax[0].idUnique,
              state: pax[i].state_id || pax[0].state_id,
              conditionInsurance: pax[i].conditionInsurance || null,
              relation_ship_catalogue_id: pax[i].relation_ship_catalogue_id || pax[0].relation_ship_catalogue_id,
              holder: i == 0 ? true : false,
          };
    }


}
